import { render, staticRenderFns } from "./SelfRegisterView.vue?vue&type=template&id=2dfa98fe&scoped=true"
import script from "./SelfRegisterView.vue?vue&type=script&lang=ts"
export * from "./SelfRegisterView.vue?vue&type=script&lang=ts"
import style0 from "./SelfRegisterView.vue?vue&type=style&index=0&id=2dfa98fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa98fe",
  null
  
)

export default component.exports